var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('h2',{staticClass:"py-5"},[_vm._v("Surat Perintah Rawat Inap")]),_c('v-btn',{attrs:{"text":"","fab":"","small":""},on:{"click":_vm.closeForm}},[_c('v-icon',[_vm._v("mdi-close")])],1),_c('v-divider'),_c('inpatient-warrant',{attrs:{"patient-data":_vm.patient,"is-detail":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }